import { ACTION } from "~vue/chatActions";
import type { ChatMessage } from "~vue/types/chat";
import { computed, type Ref } from "vue";

export function useCollaborationExplorations(messages: Ref<ChatMessage[]>) {
    return computed(() => {
        const explored = new Set<string>();
        for (const message of messages.value) {
            for (const line of message.lines) {
                if (line.type !== "action" || line.action_name !== ACTION.EXPLORE_COLLABORATION) {
                    continue;
                }
                const card = line.action_params.card;
                if (card.status === "complete" && card.connection_id) {
                    explored.add(card.connection_id);
                }
            }
        }
        return explored;
    });
}
